import {defineStyles, useThemedStyles} from './styles/style'

import {ActionButton} from './ActionButton'
import React from 'react'
import {ReactNode} from 'react'
import {SVG} from '.'

interface StickyBannerProps {
  children: ReactNode
  dismiss?: () => void
  style?: React.CSSProperties
}

export function StickyBanner({children, dismiss, style}: StickyBannerProps) {
  const s = useThemedStyles(styles)
  return (
    <div style={s.banner}>
      <div style={style ?? {}} className="content">
        {children}
      </div>
      {dismiss && (
        <ActionButton
          appearance="plain"
          size="small"
          color="neutral"
          onClick={dismiss}
          iconCreator={(color) => <SVG.CloseSmall color={color} />}
        />
      )}
    </div>
  )
}

const styles = defineStyles((theme, font) => ({
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100vw',
    backgroundColor: theme.core.b2,
    color: theme.core.f1,
    padding: '12px 24px 12px 12px',
    zIndex: 100,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '12px',
    alignItems: 'center',
    ...font.subhead
  }
}))
